// extracted by mini-css-extract-plugin
module.exports = {"non-interactive-section":"non-interactive-section__cjJNj"};